import { render, staticRenderFns } from "./serverMove.vue?vue&type=template&id=4b1fd0a0&scoped=true"
import script from "./serverMove.vue?vue&type=script&lang=js"
export * from "./serverMove.vue?vue&type=script&lang=js"
import style0 from "./serverMove.vue?vue&type=style&index=0&id=4b1fd0a0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1fd0a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\gitee\\fcops_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b1fd0a0')) {
      api.createRecord('4b1fd0a0', component.options)
    } else {
      api.reload('4b1fd0a0', component.options)
    }
    module.hot.accept("./serverMove.vue?vue&type=template&id=4b1fd0a0&scoped=true", function () {
      api.rerender('4b1fd0a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workOrder/dcopsTicket/serverMove.vue"
export default component.exports